import { BaseIconComponent } from './BaseIcon';
import React from 'react';


export function StarIconComponent() {
    return (
        <BaseIconComponent width="24" height="25">
            <defs>
                <filter id="star-soft-clow" width="300%" height="300%" x="-100%" y="-100%">
                    <feGaussianBlur in="thicken" edgeMode="none" stdDeviation="1.5" result="blur" />
                </filter>
            </defs>
            <g transform="translate(-150 -244)">
                <g transform="translate(-111.695 124.495)">
                    <g transform="translate(0 10)">
                        <path d="M7.046.369a.662.662,0,0,0-1.187,0l-1.481,3a.663.663,0,0,1-.5.362L.567,4.214A.662.662,0,0,0,.2,5.342L2.6,7.679a.662.662,0,0,1,.19.586l-.566,3.3a.662.662,0,0,0,.96.7L6.145,10.7a.661.661,0,0,1,.616,0l2.963,1.558a.662.662,0,0,0,.96-.7l-.566-3.3a.661.661,0,0,1,.19-.586l2.4-2.337a.662.662,0,0,0-.367-1.129L9.026,3.732a.662.662,0,0,1-.5-.362Z" transform="translate(267.242 115.836)" fill="currentColor"/>
                        <path filter='url(#star-soft-clow)' d="M8.527,3.37a.662.662,0,0,0,.5.362l3.313.481A.662.662,0,0,1,12.7,5.342l-2.4,2.337a.661.661,0,0,0-.19.586l.566,3.3a.662.662,0,0,1-.96.7L6.76,10.7a.661.661,0,0,0-.616,0L3.182,12.261a.662.662,0,0,1-.96-.7l.566-3.3a.662.662,0,0,0-.19-.586L.2,5.342A.662.662,0,0,1,.567,4.214L3.88,3.732a.663.663,0,0,0,.5-.362l1.481-3a.662.662,0,0,1,1.187,0" transform="translate(267.242 115.836)" fill="currentColor"/>
                    </g>
                </g>
            </g>
        </BaseIconComponent>
    )
};